<!-- ── Scan Tracking Number — console-v2's `scanTrackIndex` dialog ───────────
     The reference is a `.confirm top modal-wide`: the title, a dark camera
     viewfinder with a green detection frame, a status
     line that turns green on a lock, then Cancel + Update.

     ONE deliberate difference from the reference. console-v2 has no camera, so
     it STAGES the scene — a fake Go Logistics sticker drifts inside the
     viewfinder and the frame locks onto its drawn barcode ("The prototype has
     no camera, so it stages the scene", its own comment). This repo has the
     real thing, so `<barcode-scanner-livestream>` fills that viewfinder
     instead and the frame locks when Quagga actually reads a code. The
     reference itself anticipates this: its sheet already carries
     `.srd-cam video, .srd-cam img { width: 100%; height: 100%; object-fit: cover }`
     for the live case.

     `[type]="scanFormats"` — a STABLE array reference, never an inline literal:
     the library's `ngOnChanges` calls `restart()`, so a new array each pass
     would restart the camera in a loop. -->
<!-- `pm-form-sheet` — the shell's shared `.srd-ms-dlg` variant, which
     console-v2 puts on this dialog as well as on despatch and Big Post. This
     one takes the VARIANT rather than a private phone block because it has no
     inner scroller of its own: its body IS the scrolling column, which is
     exactly the shape the variant is built for (the body becomes the scroller,
     the foot takes `margin-top: auto` + `position: sticky` and rides the
     bottom edge). Despatch and Big Post keep a static head and foot around
     their own pane — the reference's "the pane scrolls, never the dialog"
     contract — so the variant's body-as-scroller would give those two nested
     scrollers; they take the box alone, from styles.css. -->
<app-pebbl-modal class="pm-form-sheet" title="Scan Tracking Number">
  <div class="stn-body">

    <!-- `.found` lights the frame. `.dead` drops it — there is no feed to
         overlay. -->
    <div class="stn-cam" [class.found]="!!sampleTrackingNumber"
         [class.dead]="scanState === 'failed'">
      <barcode-scanner-livestream #scanner [type]="scanFormats"
                                  (valueChanges)="onValueChanges($event)"></barcode-scanner-livestream>

      <!-- No staged sticker and no sweep line (client, Oct): the viewfinder
           is the live camera feed and a still detection frame, nothing else.
           Until the feed arrives the status line below says "Starting the
           camera…". -->
      @if (scanState !== 'failed') {
        <span class="stn-cam-frame" aria-hidden="true"></span>
      } @else {
        <span class="stn-cam-off" aria-hidden="true">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
            <path d="M1 1l22 22"/>
          </svg>
        </span>
      }
    </div>

    <!-- The real state, not a one-second timer. The old dialog cleared its
         (invisible) `.page-loader` after 1s whether or not the camera had
         started, so a blocked camera and a camera that had simply not seen a
         barcode yet both read "Scanning…" for ever. -->
    <div class="stn-status" aria-live="polite">
      @if (sampleTrackingNumber) {
        <span class="ok">Found <b>{{ sampleTrackingNumber }}</b></span>
        <button type="button" class="stn-again" (click)="scanAgain()">Scan again</button>
      } @else if (scanState === 'starting') {
        Starting the camera…
      } @else if (scanState === 'failed') {
        <span class="bad">{{ scanError }}</span>
        <button type="button" class="stn-again" (click)="scanAgain()">Try the camera again</button>
      } @else {
        Scanning…
        <button type="button" class="stn-again" (click)="manualOpen = !manualOpen">Enter it instead</button>
      }
    </div>

    <!-- The typed way through. A warehouse PC with no webcam, a denied camera
         permission, or a number printed as text rather than as a barcode all
         end here — and before this the dialog had no exit but Cancel. -->
    @if (manualOpen && !sampleTrackingNumber) {
      <div class="stn-manual">
        <label class="stn-manual-lab" for="stn-manual-input">Tracking number</label>
        <div class="stn-manual-row">
          <input id="stn-manual-input" type="text" inputmode="numeric" autocomplete="off"
                 placeholder="e.g. 2013845879"
                 [(ngModel)]="manualEntry" (keydown.enter)="useManualEntry()"/>
          <button type="button" class="btn-secondary btn-sm" [disabled]="!manualEntry.trim()"
                  (click)="useManualEntry()">Use this number</button>
        </div>
        <span class="stn-manual-hint">Spaces are removed - “1800 428 437” is stored as 1800428437.</span>
      </div>
    }

    <!-- Both actions keep the bindings they already had — `ngbActiveModal.close()`
         for Cancel and `updateTrackingNumber()` for Update, which is what
         raises the success toast, closes with the code and stops the scanner. -->
    <div class="pm-foot">
      <button type="button" class="btn-secondary" (click)="ngbActiveModal.close()">Cancel</button>
      <button type="button" class="btn-primary" [disabled]="!sampleTrackingNumber"
              (click)="updateTrackingNumber()">Update</button>
    </div>
  </div>
</app-pebbl-modal>
